// @flow
import type { FullState } from '../../../types';
import type { Filter, Filters } from '../../types';

export const selectFiltersValues = (state: FullState): Filters =>
  state.domainSuggest.filters;

export const selectFilterValue = (state: FullState, filter: Filter): string =>
  selectFiltersValues(state)[filter];
